export default __webpack_public_path__ + "static/media/AboutUs2.1e0fbb15.svg";